import React from 'react';
import PlaceHolderImage from '../../../assets/Images/placeholderimg.png'
import {MyCustomImageInterface} from './interface'

const CustomImages = ({ src }: MyCustomImageInterface) => {
    const customStyle = {
        height: "75%",
        width: "100%",
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${src ? src : PlaceHolderImage})`
    };

    return (
        <div className="myComponent" style={customStyle}></div>
    );
}

export default CustomImages;
